import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dasboard',
  templateUrl: './dasboard.component.html',
  styleUrls: ['./dasboard.component.sass']
})
export class DasboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
